import React from 'react';
import { useTranslation } from 'react-i18next';
import '../css/style.css';

const Mantenimiento = () => {
  const { t } = useTranslation();

  return (
    <div className="mantenimiento-container">
      <div className="mantenimiento-content">
        <img
          src="/images/logoadhoc.svg"
          alt={t('comun.marcaLogo')}
          className="mantenimiento-logo"
        />
        <h1>{t('estados.mantenimientoTitulo')}</h1>
        <p>{t('estados.mantenimientoTexto')}</p>
        <p className="mantenimiento-footer">
          {t('estados.mantenimientoTelefono')}{' '}
          <a href="tel:+34856901276">856 901 276</a>
        </p>
      </div>
    </div>
  );
};

export default Mantenimiento;
